import {
  BillingReportList,
  MilestoneReportQueryParams,
  ProjectMilestoneQueryParams,
} from '../../../../types/Invoicing/ProjectMilestones/projectMilestonetype'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, ProjectMilestoneApiConfig } from '../../apiList'

const getBillingReportSearch = async (
  queryParams: ProjectMilestoneQueryParams,
): Promise<BillingReportList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: ProjectMilestoneApiConfig.billingReportonSearch,
    method: AllowedHttpMethods.get,
    params: queryParams,
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const billingReport = async (
  queryParams: MilestoneReportQueryParams,
): Promise<BillingReportList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: ProjectMilestoneApiConfig.billingReport,
    method: AllowedHttpMethods.get,
    params: queryParams,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const reOpenMilestone = async (milestoneId: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: ProjectMilestoneApiConfig.reOpenMilestone,
    method: AllowedHttpMethods.get,
    params: {
      milestoneId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const projectMilestonesListApi = {
  billingReport,
  getBillingReportSearch,
  reOpenMilestone,
}

export default projectMilestonesListApi
